<template>
  <div>
  <h2>Biography</h2>
  <div class="box-content">
    <ul class="timeline">
      <li v-for="item in biography">
        <p class="timeline-date">
          {{ item.year }}-{{ item.month }}
        </p>
        <p class="timeline-title">
          {{ item.title }}
        </p>
      </li>
    </ul>
  </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters('About',{
        'biography': 'getBiography'
      })
    }
  }
</script>
<style scoped>
  .timeline{
    text-align: left;
    list-style: none;
    padding-left: 0;
  }
  .timeline > li{
    margin-bottom: 40px;
  }
  .timeline-title{
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/modules/BiographyList.vue